
import React from 'react'
import PropTypes from 'prop-types'
import TableRow from '@material-ui/core/TableRow'
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import SessionListActions from './SessionListActions'

const SessionListFooter = ({ length, rowsPerPage, page, onChangePage, onChangeRowsPerPage }) => (
  <TableFooter>
    <TableRow>
      <TablePagination
        colSpan={5}
        count={length}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={onChangePage}
        onChangeRowsPerPage={onChangeRowsPerPage}
        ActionsComponent={SessionListActions}
      />
    </TableRow>
  </TableFooter>
)

SessionListFooter.propTypes = {
  length: PropTypes.number,
  rowsPerPage: PropTypes.number,
  page: PropTypes.number,
  handleChangePage: PropTypes.func,
  handleChangeRowsPerPage: PropTypes.func
}

export default SessionListFooter



// WEBPACK FOOTER //
// ./src/components/setup/recall-session/by-decision/SessionList/Desktop/SessionListFooter.js